export default "__VITE_ASSET__0011a0a8__"